import {
  HTTP_GETBUDGETSDETAIL_FETCHING,
  HTTP_GETBUDGETSDETAIL_SUCCESS,
  HTTP_GETBUDGETSDETAIL_FAILED,
} from "././../../Constants";

const initialState = {
  result: [],
  isFetching: false,
  isError: false,
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case HTTP_GETBUDGETSDETAIL_FETCHING:
      return {
        ...state,
        result: [],
        isFetching: true,
        isError: false,
      };
    case HTTP_GETBUDGETSDETAIL_SUCCESS:
      return {
        ...state,
        result: payload.data,
        isFetching: false,
        isError: false,
      };
    case HTTP_GETBUDGETSDETAIL_FAILED:
      return {
        ...state,
        result: [],
        isFetching: false,
        isError: true,
      };
    default:
      return state;
  }
};
